/* eslint-disable react/no-array-index-key */
import { memo, useMemo } from 'react'
import { Skeleton } from '@/components/ui/skeleton'

export const SkeletonCard = () => <Skeleton className='h-20 w-full rounded-lg' />
export const SkeletonCardWithTitle = () => (
  <div className='flex min-h-20 w-full flex-col items-start justify-between space-y-2 rounded-lg bg-white p-4 shadow-sm'>
    <Skeleton className='h-6 w-full rounded-lg' />
    <Skeleton className='h-6 w-20 rounded-full' />
  </div>
)
export const SkeletonCardWithDescription = () => (
  <div className='flex min-h-40 w-full flex-col items-start justify-between rounded-lg bg-white p-4 shadow-sm'>
    <div className='flex w-full flex-col gap-2'>
      <Skeleton className='h-6 w-full rounded-lg' />
      <Skeleton className='h-10 w-full rounded-lg' />
    </div>
    <Skeleton className='h-6 w-20 rounded-full' />
  </div>
)

export const SkeletonCardList = memo(({ num = 3, type = `card` }: { num?: number; type?: `card` | `card-with-title` | `card-with-description` }) => {
  const skeletons = useMemo(
    () =>
      Array.from({ length: num }).map((_, index) => {
        if (type === `card`) return <SkeletonCard key={index} />
        if (type === `card-with-title`) return <SkeletonCardWithTitle key={index} />
        if (type === `card-with-description`) return <SkeletonCardWithDescription key={index} />
        return <SkeletonCard key={index} />
      }),
    [num, type]
  )

  return <div className='flex w-full items-center gap-4'>{skeletons}</div>
})
